/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `pct` - procent
 * * `amt` - kwota
 */
export type GoalAllocationModeEnum = typeof GoalAllocationModeEnum[keyof typeof GoalAllocationModeEnum];


export const GoalAllocationModeEnum = {
  pct: 'pct',
  amt: 'amt',
} as const;
